// The pieces learner screens share. Most live in files of their own and are
// re-exported here, so a screen imports every building block from one place.

import type { ReactNode } from 'react'

import { LanguageSwitcher } from '../i18n'

export { Icon, ICON_NAMES } from './icons'
export type { IconName } from './icons'
export { PhoneInput, toE164Uz, formatUzPhone, nationalDigits } from './phone'
export { Dropzone, accepts } from './files'
export { messageOf, fieldErrorOf } from './errors'
export { Logo } from './brand'

/**
 * The frame of a signed-out page — sign in, register: the page itself, with
 * the language picker in the top right corner, where a first-time visitor
 * looks for it before reading anything else.
 */
export function SignedOutFrame({ children }: { children: ReactNode }) {
  return (
    <div className="signed-out">
      <div className="signed-out__lang">
        <LanguageSwitcher />
      </div>
      {children}
    </div>
  )
}
